import paymentTermService from '../services/payment-term'
import {
  SET_PAYMENT_TERMS,
  SET_PAYMENT_TERMS_LOADING,
  SET_PAYMENT_TERMS_ERROR,
  REMOVE_PAYMENT_TERM
} from '../mutation-types'

// State
export const state = {
  paymentTerms: [],
  loading: false,
  error: null
}

// Getters
export const getters = {
  paymentTerms: state => state.paymentTerms,
  activePaymentTerms: state => state.paymentTerms.filter(pt => pt.is_active),
  paymentTermsLoading: state => state.loading,
  paymentTermsError: state => state.error
}

// Mutations
export const mutations = {
  [SET_PAYMENT_TERMS](state, paymentTerms) {
    state.paymentTerms = paymentTerms
  },

  [SET_PAYMENT_TERMS_LOADING](state, loading) {
    state.loading = loading
  },

  [SET_PAYMENT_TERMS_ERROR](state, error) {
    state.error = error
  },

  [REMOVE_PAYMENT_TERM](state, id) {
    state.paymentTerms = state.paymentTerms.filter(pt => pt.id !== id)
  }
}

// Actions
export const actions = {
  async fetchPaymentTerms({ commit }, { admin = false } = {}) {
    commit(SET_PAYMENT_TERMS_LOADING, true)
    commit(SET_PAYMENT_TERMS_ERROR, null)
    try {
      const { data } = admin
        ? await paymentTermService.getAllAdmin()
        : await paymentTermService.getAll()
      commit(SET_PAYMENT_TERMS, data.results || [])
      return data
    } catch (error) {
      commit(SET_PAYMENT_TERMS_ERROR, error.response?.data?.message || 'Failed to fetch payment terms')
      throw error
    } finally {
      commit(SET_PAYMENT_TERMS_LOADING, false)
    }
  },

  async fetchActivePaymentTerms({ commit }) {
    commit(SET_PAYMENT_TERMS_LOADING, true)
    commit(SET_PAYMENT_TERMS_ERROR, null)
    try {
      const { data } = await paymentTermService.getAll()
      commit(SET_PAYMENT_TERMS, data.results || [])
      return data
    } catch (error) {
      commit(SET_PAYMENT_TERMS_ERROR, error.response?.data?.message || 'Failed to fetch payment terms')
      throw error
    } finally {
      commit(SET_PAYMENT_TERMS_LOADING, false)
    }
  },

  async createPaymentTerm({ commit, dispatch }, payload) {
    commit(SET_PAYMENT_TERMS_LOADING, true)
    try {
      const { data } = await paymentTermService.create(payload)
      await dispatch('fetchPaymentTerms', { admin: true })
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_PAYMENT_TERMS_LOADING, false)
    }
  },

  async updatePaymentTerm({ commit, dispatch }, { id, payload }) {
    commit(SET_PAYMENT_TERMS_LOADING, true)
    try {
      const { data } = await paymentTermService.update(id, payload)
      await dispatch('fetchPaymentTerms', { admin: true })
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_PAYMENT_TERMS_LOADING, false)
    }
  },

  async deletePaymentTerm({ commit, dispatch }, id) {
    commit(SET_PAYMENT_TERMS_LOADING, true)
    try {
      const { data } = await paymentTermService.delete(id)
      commit(REMOVE_PAYMENT_TERM, id)
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_PAYMENT_TERMS_LOADING, false)
    }
  },

  async updatePaymentTermOrder({ commit, dispatch }, ids) {
    commit(SET_PAYMENT_TERMS_LOADING, true)
    try {
      const { data } = await paymentTermService.updateOrder(ids)
      await dispatch('fetchPaymentTerms', { admin: true })
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_PAYMENT_TERMS_LOADING, false)
    }
  }
}
